import { createAsyncThunk } from '@reduxjs/toolkit'
import doAsync from '../../infrastructure/doAsync'

export const fetchUser = createAsyncThunk(
	'fetch/user',
	async (
		{ id, showNoError, useCaching = true, noBusySpinner } = {},
		thunkArgs
	) =>
		await doAsync({
			url: `api/backofficeusers/${id}`,
			useCaching,
			noBusySpinner,
			errorMessage: 'Unable to fetch user. Please try again later.',
			showNoError,
			...thunkArgs,
		})
)
